import React from 'react';
import { motion } from 'framer-motion';
import { CONFIG } from '../config';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiBriefcase } = FiIcons;

const Coverage = () => {
  return (
    <div id="coverage" className="max-w-6xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass border-white/5 text-blue-400 text-[10px] font-black uppercase tracking-widest mb-6">
            <SafeIcon icon={FiMapPin} /> Sydney Based, Australia Wide
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white font-display mb-8 leading-tight">
            Nationwide <span className="text-blue-500">Authority</span>
          </h2>
          <p className="text-slate-400 text-lg leading-relaxed mb-10 font-medium">
            We architect professional websites and digital authority for firms across every state and territory. Our local SEO framework is designed to dominate search results in major metros like Sydney and Melbourne, as well as regional hubs.
          </p>
          <div className="grid grid-cols-4 gap-4">
            {CONFIG.AU_STATES.map(state => (
              <div key={state} className="glass py-3 text-center rounded-xl border-white/5 text-[10px] font-black text-slate-400 uppercase tracking-widest">
                {state}
              </div>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500 font-medium">
            {CONFIG.METROS.map(city => (
              <span key={city} className="flex items-center gap-2">
                <span className="w-1 h-1 rounded-full bg-blue-500" /> {city}
              </span>
            ))}
          </div>
        </div>

        <div className="glass-strong p-10 rounded-[2.5rem] border-white/10">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 rounded-2xl bg-blue-500/10 flex items-center justify-center border border-blue-500/20">
              <SafeIcon icon={FiBriefcase} className="text-blue-500 text-xl" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white font-display">Sector Expertise</h3>
              <p className="text-xs text-slate-500 uppercase tracking-widest mt-1">Inclusive Authority Architecture</p>
            </div>
          </div>
          <p className="text-sm text-slate-400 mb-8 leading-relaxed">
            {CONFIG.POSITIONING_LINE}
          </p>
          <div className="flex flex-wrap gap-2">
            {CONFIG.INDUSTRIES.map(industry => (
              <div key={industry} className="px-4 py-2 rounded-lg bg-white/5 border border-white/5 text-[10px] font-bold text-slate-300 uppercase tracking-widest hover:border-blue-500/30 hover:bg-blue-500/5 transition-all">
                {industry}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coverage;